<section class="content tab-section d-flex flex-column">
    <div class="content-block flex-grow-1">
        <div class="d-flex justify-content-between flex-wrap align-items-center">
            <div class=" search-cont">
                <div class=" s-in form-input">
                    <input type="text" class="form-control" placeholder="{{'COMMON.SEARCH' | translate}}"  (input)="onSearch($event)" (keyup.enter)="onGo()" [(ngModel)]="searchInput">
                    <mat-icon class="input-icon">search</mat-icon>
                </div>
                <div class="go-b" (click)="onGo()">{{'COMMON.GO' | translate}}</div>

            </div>
            <button mat-raised-button color="primary" class="primary-btn  mb-md-0 no-sh-btn s-lbtn" type="submit"
                (click)="onAddEditDepartment('')"><i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} {{"COMMON.DEP" | translate}}</button>
        </div>
        <div class="heading-2 new-h mt-2">
            <div class="s-bt" (click)="onAddEditDepartment('')"> <i class="fas fa-plus text-white"></i> {{"COMMON.ADD" | translate}} {{"COMMON.DEP" | translate}}</div>
          </div>
        <div class="tab-content flex-grow-1 d-flex flex-column mt-3">
            <div class="flex-grow-1 white-bg d-flex align-items-center justify-content-center "
                style="position: relative" *ngIf="isSpinnerLoading">
                <div class="custom-loader"></div>
            </div>
            <div class="table-container normal-td flex-grow-1 " *ngIf="!isSpinnerLoading">
                <table class="" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
                    class="mat-elevation-z8" *ngIf="dataSource.data.length!=0">

                    <ng-container matColumnDef="dep_name">
                        <th mat-header-cell *matHeaderCellDef >{{"MENUITEMS.DEPARTMENT.DEPNAME"|translate}}</th>
                        <td mat-cell *matCellDef="let element"> {{element.dep}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="width:125px"> {{"COMMON.ACTION"|translate}}</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <div class="d-flex align-items-center ">
                                <div class=" action-btn " matTooltip="{{'COMMON.EDIT' | translate}}" (click)="onAddEditDepartment(element)">
                                    <img src="assets/images/icons/edit-icon.svg" class="img-fluid  icon" alt="">
                                </div>
                                <div class=" action-btn" (click)="onViewManager(element)" matTooltip="{{'MENUITEMS.DEPARTMENT.VIEWASSIGNEDUSER' | translate}}">
                                    <img src="assets/images/icons/assign_ic (1).svg" class="img-fluid  icon">
                                  </div>  
                                <div class="action-btn" matTooltip="{{'BUTTON.DELETE' | translate}}" (click)="onDelete(element.cd_i)">
                                    <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="mat-table__message" *ngIf="dataSource?.data.length==0">
                    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
                </div>
            </div>
            <div class="pagination-cont" *ngIf="dataSource?.data.length!=0">
                <div class="show-item">
                    {{"COMMON.SIP" | translate}}
                    <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                        [(ngModel)]="config.itemsPerPage">
                        <option [value]="item" *ngFor="let item of pageSizeOptions"> {{ item }} </option>
                    </select>
                </div>
                <div class="page-c">
                    <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage"
                        [pageSize]="config.itemsPerPage" [maxSize]="maxPaginationSize"
                        (pageChange)="onPageChange($event)"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</section>